// eslint-disable-next-line import/prefer-default-export
export { default as PreloadFonts } from "./preload-fonts"